import { render, staticRenderFns } from "./InputLinkFormat.vue?vue&type=template&id=56296979"
import script from "./InputLinkFormat.vue?vue&type=script&lang=js"
export * from "./InputLinkFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports